import { render, staticRenderFns } from "./DownloadAppPopover.vue?vue&type=template&id=07b91855"
import script from "./DownloadAppPopover.vue?vue&type=script&lang=ts"
export * from "./DownloadAppPopover.vue?vue&type=script&lang=ts"
import style0 from "./DownloadAppPopover.vue?vue&type=style&index=0&id=07b91855&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports